import React from 'react';

const ProducteurPresent = ({ userId, biasseFiche, onFicheChange }) => {

    // Sécurité de type : on convertit tout en String pour éviter les conflits Nombre/Chaîne
    const isPresent = biasseFiche?.bParticipants?.some(id => String(id) === String(userId));
    const selectedValue = isPresent ? '3' : '1';

    const handleChange = (e) => {
        const value = e.target.value;

        // 1. On clone et met à jour les participants
        let updatedParticipants = biasseFiche.bParticipants ? [...biasseFiche.bParticipants] : [];

        if (value === '3') {
            const alreadyIn = updatedParticipants.some(id => String(id) === String(userId));
            if (!alreadyIn) {
                const originalType = updatedParticipants.length > 0 ? typeof updatedParticipants[0] : 'string';
                updatedParticipants.push(originalType === 'number' ? Number(userId) : String(userId));
            }
        } else if (value === '1') {
            updatedParticipants = updatedParticipants.filter(id => String(id) !== String(userId));
        }

        // 2. On crée la nouvelle version de la fiche
        const updatedFiche = { ...biasseFiche, bParticipants: updatedParticipants };

        // 3. On fait remonter l'information au parent
        onFicheChange(updatedFiche);
    };

    return (
        <div className="container mt-2 d-inline-block w-auto">
            <div className="btn-group" role="group" aria-label="Présence producteur">
                {/* Option 1 : Absent */}
                <input
                    type="radio"
                    className="btn-check"
                    name={`presence-radio-${biasseFiche.bNum}`} // <-- UNIQUE POUR CHAQUE BIASSE
                    id={`option1-${biasseFiche.bNum}`}         // <-- UNIQUE POUR CHAQUE BIASSE
                    value="1"
                    autoComplete="off"
                    checked={selectedValue === '1'}
                    onChange={handleChange}
                />
                <label className="btn btn-sm btn-outline-primary" htmlFor={`option1-${biasseFiche.bNum}`} title="Absent" style={{ color: '#666666', borderColor: '#333' }}>
                    <i className="fa-solid fa-shop-slash"></i>
                </label>

                {/* Option 3 : Présent */}
                <input
                    type="radio"
                    className="btn-check"
                    name={`presence-radio-${biasseFiche.bNum}`} // <-- UNIQUE POUR CHAQUE BIASSE
                    id={`option3-${biasseFiche.bNum}`}         // <-- UNIQUE POUR CHAQUE BIASSE
                    value="3"
                    autoComplete="off"
                    checked={selectedValue === '3'}
                    onChange={handleChange}
                />
                <label className="btn btn-sm btn-outline-primary" htmlFor={`option3-${biasseFiche.bNum}`} title="Présent" style={{ color: '#BF5214', borderColor: '#333' }}>
                    <i className="fa-solid fa-shop"></i>
                </label>
            </div>


        </div>
    );
};

export default ProducteurPresent;